import React, { useEffect, useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { getRoles } from "../services/settings";
import toast from "react-hot-toast";
import { createUser } from "../services/userServices";

const CreateUserPopup = ({ onClose, setCreate }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [address, setAddress] = useState("");
  const [roleId, setRoleId] = useState("");
  const [loading, setLoading] = useState("");

  const [roles, setRoles] = useState([]);
  const queryClient = useQueryClient();

  const fetchRoles = async () => {
    try {
      const res = await getRoles();
      setRoles(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleGenderChange = (e) => {
    setGender(e.target.value);
  };

  const handleRoleChange = (e) => {
    setRoleId(e.target.value);
  };

  // Ref to the background overlay div
  const overlayRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //setLoading(true);
    try {
      const response = await createUser({
        firstName,
        lastName,
        emailAddress,
        phoneNumber,
        gender,
        address,
        roleId,
      });
      toast.success(response.message);
      setCreate(false);
      queryClient.invalidateQueries({ queryKey: ["fetchAllUsers"] });
    } catch (error) {
      if (error.response) {
        setLoading(false);
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div
      className="
        fixed inset-0 flex items-center justify-center z-50 md:items-start md:justify-end"
    >
      <div
        ref={overlayRef}
        className="fixed inset-0 bg-black opacity-50 md:bg-none md:opacity-0"
        onClick={onClose}
      ></div>
      <div className="fixed md:absolute md:top-0 md:right-0 w-4/5 md:w-[409px] bg-white rounded-lg shadow-lg p-4 z-50 min-h-screen max-h-[100vh] overflow-auto">
        <div className="bg-white p-3">
          <div className="flex items-center justify-between">
            <h1 className="text-[20px] font-bold text-navy-blue">
              Create User
            </h1>
            <button
              className="flex justify-center text-[#E71D36] bg-[#E71D36]/20 rounded-3xl w-[30px] h-[30px]"
              onClick={onClose}
            >
              x
            </button>
          </div>

          <div className="flex flex-col mt-4">
            <form onSubmit={handleSubmit}>
              <div className="flex flex-col">
                <label htmlFor="first-name">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="John "
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>

              <div className="flex flex-col">
                <label htmlFor="last-name">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Deo"
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>

              <div className="flex flex-col mt-2">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="emailAddress"
                  onChange={(e) => setEmailAddress(e.target.value)}
                  placeholder="example@gmail.com"
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>

              <div className="flex flex-col mt-2">
                <label htmlFor="phone-no">Phone Number</label>
                <input
                  type="text"
                  id="phoneNumber"
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  placeholder="08033045559"
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>

              <div className="flex flex-col mt-2">
                <label for="gender">Gender</label>
                <select
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                  id="gender"
                  name="gender"
                  onChange={handleGenderChange}
                >
                  <option value="" selected disabled hidden>
                    Select Gender
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>

              <div className="flex flex-col mt-2">
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="2239  Anthony Villlage"
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                />
              </div>

              <div className="flex flex-col mt-2">
                <label htmlFor="user-role">User's Role</label>
                <select
                  id="roleId"
                  placeholder="Front Desk Officer"
                  className="h-[50px] bg-form-background p-2 mt-2 rounded-md text-navy-blue focus:outline-none"
                  onChange={handleRoleChange}
                >
                  <option value="">Select Role</option>
                  {roles.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mt-6">
                <button
                  className="w-full h-[50px] bg-primary text-white text-base font-semibold rounded-md disabled:bg-[rgba(var(--primary-rgb),0.2)]"
                  type="submit"
                  disabled={roleId === ""}
                >
                  Create User
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateUserPopup;
